import request from '@/utils/request'

export function updateUserPassword(data) {
  return request({
    url: '/user/v1/password/update',
    method: 'post',
    data: data
  })
}

export function forgetUserPassword(data) {
  return request({
    url: '/user/v1/forget/password/update',
    method: 'post',
    data: data
  })
}

export function registerUser(data) {
  return request({
    url: '/user/v1/register',
    method: 'post',
    data: data
  })
}

export function sendUserCode(data) {
  return request({
    url: '/user/v1/send/code',
    method: 'post',
    data: data
  })
}

export function updateUserCode(data) {
  return request({
    url: '/user/v1/info/update',
    method: 'post',
    data: data
  })
}

export function getUserInfoList(params) {
  return request({
    url: '/user/v1/query/info/byAccount',
    method: 'get',
    params
  })
}
